import create from "zustand";
import { DataProps } from "./types";

export const useCommodity = create<DataProps>((set) => ({
  data: {},
  setData: (item) => set((state) => ({ data: (state.data = item) })),
}));
